import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageSeo } from '../data/siteSeo';
import { setPageSeo } from '../utils/seo';
import { buildSiteSchema, serializeSchema } from '../utils/siteSchema';

export const SiteSeo = () => {
  const { pathname } = useLocation();
  const page = getPageSeo(pathname);
  useEffect(() => { setPageSeo(page); }, [pathname, page]);
  return <script type="application/ld+json" data-testid="site-structured-data">{serializeSchema(buildSiteSchema(page))}</script>;
};